export const Footer = () => {
    return (
        <div className="footer-container">
            <div className={"admin-data"}>
                <div>Page Administrator </div>
                <div>Jakub Krawczyk</div>
                <div>✉️ contact@jakubkrawczyk.com</div>
                <div></div>
            </div>
            
            <div className={"footer-resources"}>
                <div>
                    <span>Odwiedź także naszą stronę międzynarodową</span>
                    <a href="https://pelna-ksiegowosc.com.pl/" target="_blank" rel="noopener noreferrer">pelna-ksiegowosc.com.pl</a>
                </div>
                <a href="https://pelna-ksiegowosc.com.pl/" target="_blank" rel="noopener noreferrer">
                <img src="/images/taxello.jpg" width={"150"}/>
                </a>
            </div>
            
        </div>
        

    )
}
